import { api } from "@/lib/api";

// Public (all authenticated users): visible plans for the Pricing/Services page.
export async function fetchPublicPackages() {
  const { data } = await api.get("/packages/public");
  return data.packages || [];
}

// Founder-only: full editable plan docs.
export async function fetchAdminPackages() {
  const { data } = await api.get("/packages/admin");
  return data.packages || [];
}

// Founder-only: persist one plan's editable fields. planId is unchanged.
export async function updatePackage(planId, payload) {
  const { data } = await api.put(`/packages/admin/${planId}`, payload);
  return data.package;
}
